class SearchTopMatches extends HTMLElement {
  connectedCallback() {
    const query = this.dataset.query;
    if (!query) return;

    const url = new URL(window.routes.predictive_search_url, window.location.origin);
    url.search = new URLSearchParams({
      q: query,
      "resources[type]": "product",
      "resources[limit]": 8,
      "resources[options][fields]": "title,product_type,variants.title,vendor,variants.sku",
      section_id: "predictive-search",
    });

    fetch(url.toString())
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const panel = doc.querySelector("#Search-Result-Products-Panel");
        if (!panel || !panel.children.length) return;

        const heading = document.createElement("div");
        heading.className = "search-top-matches__heading";
        heading.textContent = `Top matches for “${query}”`;

        const grid = document.createElement("div");
        grid.className = "search-top-matches__grid";
        while (panel.firstChild) {
          grid.appendChild(panel.firstChild);
        }

        this.appendChild(heading);
        this.appendChild(grid);
        this.classList.add("is-visible");

        if (typeof webvista !== "undefined" && webvista.initLazyImages) {
          webvista.initLazyImages();
        }
      })
      .catch(() => {});
  }
}

customElements.define("search-top-matches", SearchTopMatches);
